<template>
  <div>
    <modal v-if="modalShow" :large="true" :element_list="modal_info" :tab_form="true" :tab_values="elements" @close="close" @save_settings="save_settings" :tabs="tabs">
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/widgets/Modal'
import Api from '@/services/Api'
import { MapMixins } from '@/mixins';


export default {
  mixins: [MapMixins],
  data() {
    return {
      language: this.$store.getters.lang,
      isLoading: false,
      alarm_options: [],
      user_alarm_list: [],
      alarms: this.$store.getters.generic.alarms,
      tabs: [
        {
          name: "Etiket Ayarları",
          value: "Burcu",
          class: 'fa fa-tag'
        },
        {
          name: "Alarm Ayarları",
          value: "Ugurcan",
          class: 'fa fa-tag'
        },
        {
          name: 'Icon Ayarları',
          value: 'icon_settings',
          class: 'fa fa-tag'
        }
      ],
      modal_info: {
        style: 'max-height: 450px',
        icon: 'fa fa-directions',
        title: this.$t('settings'),
        segments: [
          {
            title: this.$t('vehicle_tags'),
            header: true,
            elements: [
              {
                html: 'checkbox',
                label: this.$t('plate'),
                type: 'checkbox',
                model: 'plate',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('vehicle_brand'),
                type: 'checkbox',
                model: 'vehicle_brand',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('vehicle_model'),
                type: 'checkbox',
                model: 'vehicle_model',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('group'),
                type: 'checkbox',
                model: 'vehicle_groups',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('speed'),
                type: 'checkbox',
                model: 'speed',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('temperature1'),
                type: 'checkbox',
                model: 'temp_sensor_1',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('temperature2'),
                type: 'checkbox',
                model: 'temp_sensor_2',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('temperature3'),
                type: 'checkbox',
                model: 'temp_sensor_3',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('temperature4'),
                type: 'checkbox',
                model: 'temp_sensor_4',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('driver'),
                type: 'checkbox',
                model: 'driver_name',
                class: 'col-md-4'
              },
              {
                html: 'checkbox',
                label: this.$t('humidity'),
                type: 'checkbox',
                model: 'humidity',
                class: 'col-md-4'
              },
            ]
          },
          {
            title: 'bbbbbb',
            header: true,
            elements: [
              {
                html: 'checkbox',
                label: this.$t('notification_sound'),
                type: 'checkbox',
                model: 'notification_sound',
                class: 'col-md-6 justify-content-center'
              },
              {
                html: 'checkbox',
                label: this.$t('notification_auto_close'),
                type: 'checkbox',
                model: 'notification_auto_close',
                class: 'col-md-6 justify-content-center'
              },
              {
                html: 'hr',
                class: 'col-md-12'
              },
            ]
          },
          {
            title: 'test',
            header: true,

            elements: [
              {
                html: 'img_div_select',
                class: 'col-md-12',
                type: 'radio',
                selected: this.$store.state.user.icon_type,
                options: [
                  { name: 'default', item: "0" },
                  { name: 'classic', item: "1" },
                  { name: 'premium', item: "2" },
                ],
              },
            ]
          }
        ],
        footer: [
          {
            html: 'button',
            type: 'button',
            label: 'Kaydet',
            class: 'btn btn-primary',
            onclick: 'save_settings',
            spinner: false
          }
        ]
      },
      elements: [{
        plate: false,
        vehicle_brand: false,
        vehicle_model: false,
        speed: false,
        group: false,
        speed: false,
        ignition: false,
        pull: false,
        idling: false,
        humidity: false,
        driver: false,
        temp_sensor_1: false,
        temp_sensor_2: false,
        temp_sensor_3: false,
        temp_sensor_4: false
      },
      {
        notification_sound: false,
        notification_auto_close: false
      }
      ]

    }
  },
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save_settings() {
      let self = this
      let notification_alarms = []
      let notification_options = []
      for (let item in this.elements[1]) {
        if (this.elements[1][item] == true && item != 'notification_sound' && item != 'notification_auto_close') {
          notification_alarms.push(parseInt(item))
        }
      }
      notification_options = {
        'notification_sound': this.elements[1]['notification_sound'] ? this.elements[1]['notification_sound'] : false,
        'notification_auto_close': this.elements[1]['notification_auto_close'] ? this.elements[1]['notification_auto_close'] : false
      }
      let params = {
        icon_type: this.modal_info.segments[2].elements[0].selected,
        tag_settings: this.elements[0],
        notification_alarms: notification_alarms,
        notification_options: notification_options
      }
      Api.post(this, 'ats/user/map_settings', { 'params': params }).then(response => {
        if (response.status) {
          this.close()
          this.$store.commit('set_tag_settings', response.tag_settings)
          this.$store.commit('set_icon_type', response.icon_type)
          this.$store.commit('set_notification_options', response.notification_options)
          this.$store.commit('set_notification_alarms', response.notification_alarms)

          this.$swal({
            type: 'success',
            title: self.$t('swal_success_title'),
            text: self.$t('swal_settings_updated')
          })
        } else {
          alert(this.$t('error'))
        }
      })
    },
    get_settings() {
      Api.get('ats/user/map_settings').then(response => {
        if (response.status) {
          this.user_alarm_list = response.data.alarm_list
          this.elements[1]['notification_sound'] = this.$store.state.user.notification_options.notification_sound
          this.elements[1]['notification_auto_close'] = this.$store.state.user.notification_options.notification_auto_close
          this.modal_info.segments[2].elements[0].selected = response.data.icon_type
        }
        let self = this
        this.alarms.map(function (item) {
          let temp = {
            'value': item.type,
            'label': item['text_' + self.language],
            'model': item.type,
            'html': 'checkbox',
            'class': 'col-md-4',
            'type': 'checkbox'
          }
          self.elements[1][item.type] = self.user_alarm_list.includes(item.type)
          self.modal_info.segments[1].elements.push(temp)
        })
      })
    },
    set_image_list() {
      this.modal_info.segments[2].elements[0].img_list = []
      for (let i = 0; i < Object.keys(this.images).length; i++) {
        let temp_array = []
        this.images[i].forEach(icon => {
          if (icon.id != 4 && icon.id != 100) {
            temp_array.push(icon.url)
          }
        });
        this.modal_info.segments[2].elements[0].img_list.push(temp_array)
      }
    }
  },
  components: {
    Modal
  },
  mounted() {
    const self = this
    for (let a in self.elements[0]) {
      this.elements[0][a] = this.$store.state.user.tag_settings.indexOf(a) !== -1 ? true : false
    }
    self.get_settings()
    self.set_image_list()
  }
}
</script>

<style scoped>

</style>
